import React from 'react'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { useParams } from 'react-router-dom'
import {
	CourseLoadSummary,
	GPASummary,
	CalculatedGPASummary,
	APScoreSummary,
	CourseLessonReport,
	CourseLessonAverageGpaReport,
	CourseLessonCalculatedGpaReport,
	CourseLessonLevelReport,
	CourseLessonGradeYearReport
} from './CourseReport'

const LessonCoursesReport = ({ studentId: propStudentId }) => {
	const { user } = useAuth()
	const { studentId: paramStudentId } = useParams()
	const isInstructorView = user?.role === 'Instructor'

	// Determine the effective student ID with proper fallback
	let effectiveStudentId = propStudentId
	if (!effectiveStudentId && isInstructorView) {
		effectiveStudentId = paramStudentId
	}
	if (!effectiveStudentId) {
		effectiveStudentId = user?.id
	}

	// Don't render if we don't have a valid student ID or user data is still loading
	if (!effectiveStudentId || !user) {
		return (
			<div className="col-12">
				<div className="text-center p-5">
					<div className="spinner-border text-primary" role="status">
						<span className="visually-hidden">Loading...</span>
					</div>
					<p className="mt-3 text-muted">Loading course report...</p>
				</div>
			</div>
		)
	}

	return (
		<div className="col-12">
			<CourseLessonLevelReport studentId={effectiveStudentId} isStudent={!isInstructorView} />
			<CourseLessonGradeYearReport studentId={effectiveStudentId} isStudent={!isInstructorView} />
			<APScoreSummary studentId={effectiveStudentId} isStudent={!isInstructorView} />
			<CourseLessonReport studentId={effectiveStudentId} isStudent={!isInstructorView} />
			<CourseLessonAverageGpaReport studentId={effectiveStudentId} isStudent={!isInstructorView} />
			<CourseLessonCalculatedGpaReport studentId={effectiveStudentId} isStudent={!isInstructorView} />
			<CourseLoadSummary studentId={effectiveStudentId} isStudent={!isInstructorView} />
			<GPASummary studentId={effectiveStudentId} isStudent={!isInstructorView} />
			<CalculatedGPASummary studentId={effectiveStudentId} isStudent={!isInstructorView} />
		</div>
	)
}

export { LessonCoursesReport }
